'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _languages = require('./languages');

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_languages).default;
    }
});

var _model = require('./model');

Object.defineProperty(exports, 'LanguageRecordType', {
    enumerable: true,
    get: function get() {
        return _model.LanguageRecordType;
    }
});
Object.defineProperty(exports, 'LanguageMapType', {
    enumerable: true,
    get: function get() {
        return _model.LanguageMapType;
    }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/languages/index.js
// module id = 448
// module chunks = 0